import { Component } from '@angular/core';
import { ApiService } from '../../../api.service';

@Component({
  selector: 'app-conditions',
  templateUrl: './conditions.component.html',
  styleUrls: ['./conditions.component.scss']
})
export class ConditionsComponent {
  
  subFamilies:any;

  offers:any;
  offersEbp:any;
  editors:any;

  selected:any;
  games:any;
  priceListIds: any[] = [];
  loading = true;
  
  constructor(public api:ApiService) { }

  ngOnInit(){
    this.api.post("SPDO=select",{database:"offer", where:'active = 1'}).then((res:any)=>{
      this.offers = res.data;
    });
    this.api.postWS("sql=select",{database:"PriceList", where:'Type = 2 AND GETDATE() BETWEEN [StartValidityDate] AND EndValidityDate'}).then((res:any)=>{
      this.offersEbp = res || [];
      this.priceListIds = this.offersEbp.map(item => item.Id);

        this.api.post("pro=getAllGames&adminOrder=true",{}).then((res:any)=>{
        this.games = res['jeux'].filter(item=>{
          if(item.ItemType == '1' && item.xx_Jeux_catalogue_GSS == '1' && item.xx_Disponible_pour_la_vente == '1' && item.cat_princ == '32'){
            item.Description = item.name;
            this.offersEbp.push(item);
            this.priceListIds.push(item.Id);
          }
          return true;
        });
        this.refresh();
      });
    });
    this.api.post("SPDO=select",{database:"editor"}).then((res:any)=>{
      this.editors = res.data;
    });
    
  }

  refresh(){
    this.loading = true;
    this.api.post("pro=getConditions",{database:'gss_condition'}).then((res:any)=>{
      if(res){
        this.subFamilies = res.filter(row =>{
          row.offerEbp_excluded = row.offerEbp_excluded.filter(id => this.priceListIds.indexOf(id) > -1);
          row.item_excluded = row.item_excluded || [];
          return true;
        });
      }
      this.loading = false;
    });
    /*this.api.postWS("sql=select",{database:'CustomerSubFamily',fields:'*',where:"CustomerFamilyId IN(SELECT Id FROM CustomerFamily WHERE xx_Espace_Pro = 'gss')",orderBy:'Caption'}).then((res:any)=>{
        res.push({
          Id:'FCL00001',
          Caption: 'BOUTIQUES'
        });
        res.push({
          Id:'FCL00003',
          Caption: 'GSS CENTRALES'
        });
        res.push({
          Id:'FCL00014',
          Caption: 'EXPORT'
        });
        this.api.post("SPDO=select",{database:'gss_condition'}).then((res2:any)=>{
          if(res2 && res2.data){
            for (let i in res){
              res[i].conditions = res2.data.find(item => item.CustomerSubFamily == res[i].Id || item.CustomerFamily == res[i].Id); 
              res[i].conditions.offer_excluded = res[i].conditions.offer_excluded ? res[i].conditions.offer_excluded.split(',').map(item => parseInt(item)) : [];
              res[i].conditions.offerEbp_excluded = res[i].conditions.offerEbp_excluded ? res[i].conditions.offerEbp_excluded.split(',').filter(id => this.priceListIds.indexOf(id) > -1) : [];
              res[i].conditions.editor_excluded = res[i].conditions.editor_excluded ? res[i].conditions.editor_excluded.split(',').map(item => parseInt(item)) : [];
            }
          }
          this.subFamilies = res;
        });
    });*/
  }

  save(row){
    let form = {
      discountRateGlobal: row.discountRateGlobal,
      offer_excluded: [...new Set(row.offer_excluded)].filter(id => this.offers.map(offer => offer.id_offer).indexOf(id) > -1).join(','),
      offerEbp_excluded: [...new Set(row.offerEbp_excluded)].join(','),
      editor_excluded: [...new Set(row.editor_excluded)].join(','),
      item_excluded: [...new Set(row.item_excluded)].join(',')
    };  

    this.api.post("SPDO=update",{database:'gss_condition',data:form,where:{id_condition : row.id_condition}}).then((res2:any)=>{
      this.refresh();
    });
  }
}
